<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-narrow has-text-centered">
        <!--<h1 class="title has-text-centered is-1">404</h1>-->
        <img src="static/error-404.png" alt="">
        <h1 class="is-margin-top has-text-centered is-size-6 has-text-grey"><i>La page demandée n'est pas disponible ou n'existe pas.</i></h1>
      </div>
    </div>
    <!--<div class="columns is-centered">
      <div class="column is-narrow">
        <router-link :to="{name: 'Home'}" class="button">Accueil</router-link>
      </div>
    </div>-->
  </div>
</template>
<script>
  export default {
    name: 'NotFound',
    data () { return {} },
    created () {
      this.$notify({
        type: 'is-danger',
        text: 'La page demandée n\'est pas disponible ou n\'existe pas.'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/404.vue